import { FigurePanel, useFigureCompositionStore } from '@/store/figure-composition';
import { Button } from '@/components/ui/button';
import { Lock, Unlock, Trash2, Plus } from 'lucide-react';

interface PanelToolbarProps {
  panel: FigurePanel;
  onAssignClick: () => void;
}

export function PanelToolbar({ panel, onAssignClick }: PanelToolbarProps) {
  const updatePanel = useFigureCompositionStore((state) => state.updatePanel);
  const removePanel = useFigureCompositionStore((state) => state.removePanel);

  const handleLockToggle = (e?: React.MouseEvent) => {
    if (e) {
      e.stopPropagation();
      e.preventDefault();
      e.nativeEvent.stopImmediatePropagation();
    }
    updatePanel(panel.id, { locked: !panel.locked });
  };

  const handleDelete = (e?: React.MouseEvent) => {
    if (e) {
      e.stopPropagation();
      e.preventDefault();
      e.nativeEvent.stopImmediatePropagation();
    }
    removePanel(panel.id);
  };

  const handleAssignClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    e.nativeEvent.stopImmediatePropagation();
    onAssignClick();
  };

  return (
    <div 
      className="absolute top-2 right-2 z-20 flex gap-1 opacity-0 group-hover:opacity-100 transition-opacity" 
      style={{ pointerEvents: 'auto' }}
      data-panel-toolbar="true"
    >
      <Button
        variant="ghost"
        size="sm"
        className="h-6 w-6 p-0 bg-white/90 hover:bg-white"
        onClick={handleAssignClick}
        onMouseDown={(e) => {
          e.stopPropagation();
          e.preventDefault();
          e.nativeEvent.stopImmediatePropagation();
        }}
        title="Assign plot"
        style={{ pointerEvents: 'auto' }}
      >
        <Plus className="h-3 w-3" />
      </Button>
      <Button
        variant="ghost"
        size="sm"
        className="h-6 w-6 p-0 bg-white/90 hover:bg-white"
        onClick={(e) => handleLockToggle(e)}
        onMouseDown={(e) => {
          e.stopPropagation();
          e.preventDefault();
          e.nativeEvent.stopImmediatePropagation();
        }}
        title={panel.locked ? 'Unlock panel' : 'Lock panel'}
        style={{ pointerEvents: 'auto' }}
      >
        {panel.locked ? (
          <Lock className="h-3 w-3" />
        ) : (
          <Unlock className="h-3 w-3" />
        )}
      </Button>
      <Button
        variant="ghost"
        size="sm"
        className="h-6 w-6 p-0 bg-white/90 hover:bg-white text-destructive hover:text-destructive"
        onClick={(e) => handleDelete(e)}
        onMouseDown={(e) => {
          e.stopPropagation();
          e.preventDefault();
          e.nativeEvent.stopImmediatePropagation();
        }}
        title="Delete panel"
        style={{ pointerEvents: 'auto' }}
      >
        <Trash2 className="h-3 w-3" />
      </Button>
    </div>
  );
}

